import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Alert from "components/common/Alert";
import BulkNotificationForm from "components/bulkNotification/BulkNotificationForm";
import { createNotification } from "api/pushNotification.api";

export default function BulkNotificationContainerPage() {
  const [alert, setAlert] = useState({ type: "", message: "" });
  const navigate = useNavigate();

  const userId = localStorage.getItem("user_id");

  return (
    <>
      {alert.message && (
        <Alert
          type={alert.type}
          message={alert.message}
          onClose={() => setAlert({ type: "", message: "" })}
          autoClose
        />
      )}

      <div className="rounded-2xl border bg-white p-6">
        <BulkNotificationForm
          initialData={null}
          onSubmit={async (formData) => {
            try {
              await createNotification({
                ...formData,
                created_by: userId,
              });
              setAlert({
                type: "success",
                message: "Notification sent successfully",
              });
              navigate("/admin/bulk-notifications");
            } catch (error) {
              setAlert({
                type: "error",
                message:
                  error.response?.data?.message ||
                  "Something went wrong while sending notification",
              });
            }
          }}
          onClose={() => navigate("/admin/bulk-notifications")}
        />
      </div>
    </>
  );
}